import { Stack, Typography } from '@mui/material';

/**
 * A side panel's title: the name of what the panel is about, as the first and
 * largest thing in it (3 Nov, Mette). Ported from Web's `ui/SidePanelHeading`
 * (the Project Portfolio's preview panel), with Web's `h3SemiBold` read as
 * this design system's `display2` — the same 20/500, which Figma names
 * display2 (see `theme/mui.d.ts`). The secondary value — a number, a code —
 * follows in parentheses, as Web shows the project number.
 */
export type SidePanelHeadingProps = {
  name: string;
  /** Rendered in parentheses after the name; nothing when empty. */
  secondary?: string | null;
  /** On the name alone, so a test can read it without the secondary value. */
  nameAutomationId?: string;
};

export const SidePanelHeading = ({ name, secondary, nameAutomationId }: SidePanelHeadingProps) => (
  <Stack direction="row" sx={{ alignItems: 'baseline', gap: 0.5, flexWrap: 'wrap', minWidth: 0 }}>
    <Typography
      component="h2"
      variant="display2"
      color="primary"
      data-automation-id={nameAutomationId}
      sx={{ m: 0, overflowWrap: 'anywhere' }}
    >
      {name}
    </Typography>
    {secondary ? (
      <Typography component="p" variant="label" color="textSecondary" sx={{ m: 0 }}>
        ({secondary})
      </Typography>
    ) : null}
  </Stack>
);
